import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router"
import { Route } from '../../interfaces/route';
import { StopsService } from '../../services/stops.service';
import { RouteService } from '../../services/route.service';
import { RouteDirectionsService } from '../../services/route-directions.service';

const rail_routes: any = Array("AIR", "CHE", "CHW", "LAN", "MED", "FOX", "NOR", "PAO", "CYN", "TRE", "WAR", "WIL", "WTR", "GC");

@Component({
  selector: 'app-schedules',
  templateUrl: './schedules.component.html',
  styleUrls: ['./schedules.component.css']
})
export class SchedulesComponent implements OnInit {

  public recent_routes: any = [];
  public routes: any = [];
  public subway_routes: string[] = ["Market/ Frankford", "Broad Street Line", "Norristown High Speed Line"];
  public trolley_routes: string[] = ["Trolley"];

  constructor(private route: ActivatedRoute, private routeService: RouteService,) {
    var recent_routes = localStorage.getItem("recent_routes");

    if (recent_routes != null) {

      if (Array.isArray(JSON.parse(recent_routes)) === true) {
        this.recent_routes = JSON.parse(recent_routes);
      }
      else {
        this.recent_routes.push(recent_routes);
      }
    }
  }

  ngOnInit(): void {

    this.routeService.get().subscribe(routes => {
      this.routes = routes;
    });
  }
}
